export const fetchReceiptPdf = async (
  userId: string,
  receiptId: string,
  lang: string,
  isDemo: boolean = false,
): Promise<Blob> => {
  const apiUrl = `/api/v3/view/users/${userId}/receipts/${receiptId}/pdf?lang=${lang}${
    isDemo ? "&demo=true" : ""
  }`;

  const response = await fetch(apiUrl, {
    headers: {
      "Content-Type": "application/json",
    },
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return response.blob();
};